'use strict';

var baseSearch = require('base/search/search');
var wishlistHeart = require('wishlist_custom/product/wishlistHeart');
const { generateResponsiveSlickCarousel, styleProductBadges } = require('../common');
var articlesCount = Number($('.articleMinCount').val()) || 0;
var tabFilterCounts = {};

/**
 * Normalize URL encoding by decoding and re-encoding query parameters
 * This ensures consistent space encoding (%20 instead of + or %2B)
 * @param {string} url - The URL to normalize
 * @returns {string} - The normalized URL
 */
function normalizeUrlEncoding(url) {
    var urlObj = new URL(url, window.location.origin);
    var normalizedParams = new URLSearchParams();
    
    urlObj.searchParams.forEach(function(value, key) {
        var decodedValue = decodeURIComponent(value.replace(/\+/g, ' '));
        normalizedParams.append(key, decodedValue);
    });
    
    urlObj.search = normalizedParams.toString();
    return urlObj.pathname + '?' + normalizedParams.toString();
}

/**
 * @param {URLSearchParams} params - URL search params
 * @returns {string|null} classificationSubSubCategory value or null
 */
function getClassificationValue(params) {
    var result = null;
    params.forEach(function (value, key) {
        var match = key.match(/^prefn(\d+)$/);
        if (match && value === 'classificationSubSubCategory') {
            result = params.get('prefv' + match[1]) || null;
        }
    });
    return result;
}

/**
 * @param {URL} ajaxUrl - parsed URL from data-href
 * @returns {string} clean URL with only category-level params
 */
function buildCleanCategoryUrl(ajaxUrl) {
    var allowedKeys = ['cgid', 'q', 'srule', 'lang'];
    var cleanParams = new URLSearchParams();

    ajaxUrl.searchParams.forEach(function (value, key) {
        if (allowedKeys.indexOf(key) !== -1) {
            cleanParams.set(key, value);
        }
    });

    // Preserve the classificationSubSubCategory pair at whatever prefn index it sits
    ajaxUrl.searchParams.forEach(function (value, key) {
        var match = key.match(/^prefn(\d+)$/);
        if (match && value === 'classificationSubSubCategory') {
            cleanParams.set(key, value);
            var prefvVal = ajaxUrl.searchParams.get('prefv' + match[1]);
            if (prefvVal) {
                cleanParams.set('prefv' + match[1], prefvVal);
            }
        }
    });

    return window.location.pathname + '?' + cleanParams.toString();
}

/**
 * Update Product tile with dynamic data
 */
function dynamicTiledata() {
    $('.atc-button-and-product-availability').each(function () {
        var pid = $(this).attr('data-productid');
        var pdWishList = $(this).find('.dynamic-wishlist');
        var pdAvailability = $(this).find('.dynamic-product-availability');
        var pdCta = $(this).find('.dynamic-cta');
        var actualTile = $('.js-grid-tile[data-pid="' + pid + '"]').filter(function () {
            return !$(this).hasClass('einstein-carousel__product-tile')
                && $(this).find('.einstein-carousel__product-tile').length === 0;
        });

        if (!actualTile.length) {
            $(this).remove();
            return;
        }

        actualTile.find('.wishlist-product').append(pdWishList);

        if (actualTile.find('.product-tile').hasClass('product-tile-discontinued')) {
            $(this).remove();
            return;
        }

        actualTile.find('.product-availability').empty().append(pdAvailability);
        var tileBottom = actualTile.find('.tile-bottom');
        if (tileBottom.find('.dynamic-cta') && tileBottom.find('.dynamic-cta').length > 0) {
            tileBottom.find('.dynamic-cta').remove();
        }
        tileBottom.append(pdCta);
        $(this).find('.dynamic-swatch-state').each(function () {
            var isSelectable = $(this).attr('data-selectable') === 'true';
            actualTile.find('.swatch-value[data-attr-value="' + $(this).attr('data-attr-value') + '"]')
                .toggleClass('selectable', isSelectable)
                .toggleClass('unselectable', !isSelectable);
        });
        $(this).remove();
    });
    wishlistHeart.hydration.run();
}

/**
 * This function updates the price and promotion data in the tile.
 */
function dynamicPriceAndPromoData() {
    $('.product-price-and-promotion').each(function () {
        var pid = $(this).attr('data-productid');
        var pdPromotion = $(this).find('.dynamic-product-promotion');
        var pdPrice = $(this).find('.dynamic-product-price');
        var actualTile = $('.js-grid-tile[data-pid="' + pid + '"]');
        if (pdPrice.length > 0) {
            actualTile.find('.price').empty().append(pdPrice);
        }
        if (pdPromotion.length > 0) {
            actualTile.find('.availability-and-promo .promotions').empty().append(pdPromotion);
        }
        $(this).remove();
    });
}

/**
 * Preserves Page Designer interrupter cards from the product grid.
 * Returns an array of {position, $card} objects for re-insertion after AJAX update.
 * @returns {Array} saved cards with their grid positions
 */
function preserveInterrupterCards() {
    var saved = [];
    var $grid = $('.tab-pane.active .product-grid');
    if (!$grid.length) {
        $grid = $('.product-grid');
    }
    $grid.find('.interrupter-card-mobile-padding').each(function () {
        var $card = $(this);
        var storedPos = $card.attr('data-original-position');
        if (!storedPos) {
            var $nextTile = $card.next('.js-tile-position');
            storedPos = $nextTile.length ? $nextTile.data('position') : null;
            if (storedPos) {
                $card.attr('data-original-position', storedPos);
            }
        }
        saved.push({ position: storedPos ? parseInt(storedPos, 10) : null, $card: $card.detach() });
    });
    return saved;
}

/**
 * Re-inserts preserved interrupter cards into the updated product grid.
 * @param {Array} savedCards - cards saved by preserveInterrupterCards
 */
function restoreInterrupterCards(savedCards) {
    if (!savedCards || !savedCards.length) return;
    var $grid = $('.tab-pane.active .product-grid');
    if (!$grid.length) {
        $grid = $('.product-grid');
    }
    savedCards.forEach(function (item) {
        if (item.position) {
            var $tile = $grid.find('.js-tile-position[data-position="' + item.position + '"]');
            // Skip restoring only if an interrupter already exists at this position
            if ($tile.length && $tile.prev('.interrupter-card-mobile-padding').length) {
                return;
            }
            if ($tile.length) {
                item.$card.insertBefore($tile);
                return;
            }
        }
        var $lastTile = $grid.find('.js-tile-position').last();
        if ($lastTile.length) {
            item.$card.insertAfter($lastTile);
        } else {
            $grid.append(item.$card);
        }
    });
}

/**
 * Update DOM elements
 *
 *  @param {string} selector - DOM element to look up in the $results
 * @param {Object} $updates - jQuery DOM element
 */
const updateDomElem = (selector, $updates) => {
    $('.tab-pane.active').find(selector).empty().html($updates.html());
    $('body').trigger('search:updateDom', selector);
};

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    if (selector !== '.plp-result-count' || $results.find(selector).length > 0) {
        updateDomElem(selector, $updates);
    } else {
        const pageType = $('.plp-result-count:visible').data('pagetype') || '';
        const productCountSelector = `.plp-result-count.${pageType}`;
        const $productCountDisplay = $(productCountSelector).find('.page-product-length');
        const $productPageCountDisplay = $(productCountSelector).find('.page-product-page-length');
        const $productPageCountInputValue = $(`.page-product-search-length.${pageType}`);
        const $productCountInputValue = $(`.page-products-count.${pageType}`);
        var countVal = $productCountInputValue.val();
        var searchLengthVal = $productPageCountInputValue.val();
        $productCountDisplay.text(parseInt(countVal, 10) || 0);
        $productPageCountDisplay.text(parseInt(searchLengthVal ? searchLengthVal.replace(/,/g, '') : '0', 10) || 0);
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeSelector = $(this)[0].className.trim().split(/\s+/).map(function (name) {
            return '.' + CSS.escape(name);
        }).join('');
        var activeDiv = $results.find(activeSelector);
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    var hasServerInterrupterCards = $results.find('.interrupter-card-mobile-padding').length > 0;
    var savedCards = hasServerInterrupterCards ? [] : preserveInterrupterCards();

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.sort-order-refinement-container',
        '.plp-result-count'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    // Re-insert interrupter cards after grid update only when the response
    // does not already include server-rendered interrupter cards.
    if (!hasServerInterrupterCards) {
        restoreInterrupterCards(savedCards);
    }

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Update filter count on reset button
 * @param {string} url - Ajax response HTML code
 */
function updateFilterCount(url) {
    const queryString = url.split('?').pop();
    if (!queryString) return;
    const params = new URLSearchParams(queryString);
    let filterCount = 0;
    const entries = Array.from(params.entries());
    filterCount = entries.reduce((count, [key, value]) => {
        const match = key.match(/^prefn(\d+)$/);
        if (match) {
            const index = match[1];
            const filterName = value;
            const filterValue = params.get(`prefv${index}`);
            if (
                filterName !== 'productType' &&
                filterName !== 'showInWebShop' &&
                filterValue
            ) {
                const values = filterValue.split('|');
                return count + values.length;
            }
        }
        return count;
    }, 0);

    // Count price filter if present
    if (params.has('pmin') || params.has('pmax')) {
        filterCount++;
    }

    // Count promotion filter if present (pmid is set by urlRefinePromotion)
    if (params.has('pmid')) {
        filterCount++;
    }

    // Count category filter if present
    /* Bugfix SC-4111 > Commenting this to ignore category (cgid) included as filter count
    if (params.has('cgid')) {
        filterCount++;
    } */

    let pageType = $('.search-nav .nav-link.active').data('tabtype')
        || $('.refinement-modal-container:visible').data('pagetype')
        || $('.refinement-modal-container').data('pagetype')
        || 'product';
    tabFilterCounts[pageType] = filterCount;

    var $productCountInputValue = $(`.recipe-filter-count.${pageType}`);
    var $activeTabPane = $('.tab-pane.active');
    var $customCountValue = $activeTabPane.length
        ? $activeTabPane.find('.filter-count-custom')
        : $('.filter-count-custom');

    if (filterCount > 0) {
        $productCountInputValue.text('(' + parseInt(filterCount, 10) + ')');
        $customCountValue.text(parseInt(filterCount, 10)).show();
    } else {
        $productCountInputValue.text('');
        $customCountValue.text('').hide();
    }
}

/**
 * Remove bottom spacing from the last visible refinement value in each filter group.
 */
function updateLastVisibleRefinementSpacing() {
    $('ul.values').each(function () {
        var $valuesList = $(this);
        var $items = $valuesList.find('> .refinements-box-container.col-12');

        $items.removeClass('last-visible-refinement-item');

        var $lastVisibleItem = $items
            .not('.refinement-value-hidden.d-none')
            .not('.d-none')
            .last();

        if ($lastVisibleItem.length) {
            $lastVisibleItem.addClass('last-visible-refinement-item');
        }
    });
}

/**
 * Creates HTML for the search results counter.
 * @param {string} type - Page type (e.g., discover, support).
 * @param {string} searchWord - Search keyword.
 * @param {number} resultsCount - Number of results shown.
 * @param {number} totalResults - Total number of results.
 * @returns {string} HTML string for the counter.
 */
function buildResultCountHTML(type, searchWord, resultsCount, totalResults) {
    var labelResultsFor = $('#labelResultsFor').val();
    var labelResults = $('#labelResults').val();
    var labelResultsOf = $('#labelResultsOf').val();
    var labelProductResults = $('#labelProductResults').val();

    return `
        ${labelResultsFor}
        <span class="search-keywords"> ${searchWord || ''} </span>
        <div class="plp-result-count ${type}" data-pagetype="${type}">
            <span>${labelResults}</span>
            <span class="page-product-length">${resultsCount}</span>
            <span>${labelResultsOf}</span>
            <span class="page-product-page-length">${totalResults}</span>
            <span>${labelProductResults}</span>
        </div>
    `;
}

/**
 * Creates HTML for the no search results counter.
 * @param {string} type - Page type (e.g., discover, support).
 * @param {string} searchWord - Search keyword.
 * @returns {string} HTML string for the counter.
 */
function buildNoResultCountHTML(type, searchWord) {
    var labelResultsFor = $('#labelNoResultsFor').val();

    return `
        ${labelResultsFor}
        <span class="search-keywords"> ${searchWord || ''} </span>
    `;
}

/**
 * Loads additional content via AJAX and appends it to the target element.
 *
 * @param {jQuery} $element - The element containing the URL for loading more content.
 * @param {jQuery} $target - The target element to which the loaded content will be appended.
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    var searchWord = $('#searchTerm').val();
    $.spinner().start();
    $('.search-result-count').addClass('d-none');

    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);

            var targetId = $target.attr('id');

            if (targetId === 'support-results') {
                var $articleTotalSizeEl = $target.find('.articleTotalSize').last();
                var $articleMinCountEl = $target.find('.articleMinCount').last();

                if ($articleTotalSizeEl.length && $articleMinCountEl.length) {
                    var articleTotalSize = parseInt($articleTotalSizeEl.val(), 10) || 0;
                    var articleMinCount = parseInt($articleMinCountEl.val(), 10) || 0;
                    if (articleMinCount > 0 && articleTotalSize > 0) {
                        var counterHTMLSupport = buildResultCountHTML('support', searchWord, articleMinCount, articleTotalSize);
                        $('.search-result-count.support').html(counterHTMLSupport);
                    } else {
                        var counterNoHTMLSupport = buildNoResultCountHTML('support', searchWord);
                        $('.search-result-count.support').html(counterNoHTMLSupport);
                    }

                }
                $('.search-result-count.support').removeClass('d-none');
            }

            if (targetId === 'discover-results') {
                var $contentTotalSizeEl = $target.find('input[name="contentTotalSize"]').last();
                var $contentSizeEl = $target.find('input[name="contentSize"]').last();

                if ($contentTotalSizeEl.length && $contentSizeEl.length) {
                    var contentTotalSize = parseInt($contentTotalSizeEl.val(), 10) || 0;
                    var contentSize = parseInt($contentSizeEl.val(), 10) || 0;

                    if (contentTotalSize > 0 && contentSize > 0) {
                        var counterHTMLDiscover = buildResultCountHTML('discover', searchWord, contentSize, contentTotalSize);
                        $('.search-result-count.discover').html(counterHTMLDiscover);
                    } else {
                        var counterNoHTMLDiscover = buildNoResultCountHTML('discover', searchWord);
                        $('.search-result-count.discover').html(counterNoHTMLDiscover);
                    }
                }
                $('.search-result-count.discover').removeClass('d-none');
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Gets the relative pathname and URL
 * @returns {string} path name + search params
 */
function getRelativeCategoryUrl() {
    var path = ((window.location.pathname.length ? window.location.pathname.replace(/\/$/, '') : '') + window.location.search);
    return path;
}


baseSearch.initActiveContentTab = function () {
    let $activeTab = $('.search-nav .nav-link.active');
    if ($activeTab.length > 0) {
        let tabType = $activeTab.data('tabtype');
        let seachResultHeadingSelector = `.search-result-count.${tabType}`;
        let resultCountSelector = `.plp-result-count.${tabType}`;
        let resultSuggestionSelector = `.suggestion-wrapper.${tabType}`;

        // hide all result counts and show active tab result count
        $('.plp-result-count').addClass('d-none');
        $(resultCountSelector).removeClass('d-none');

        // hide all search result headings and show active tab heading
        $('.search-result-count').addClass('d-none');
        $(seachResultHeadingSelector).removeClass('d-none');

        // hide all suggestion wrappers and show active tab suggestion wrapper
        $('.suggestion-wrapper').addClass('d-none');
        $(resultSuggestionSelector).removeClass('d-none');
    }
    $(document).on('click', '.show-more-content button', function () {
        getContent($(this), $('#discover-results'));
        $('.show-more-content').remove();
    });

};

baseSearch.showContentTab = function () {
    // handle the show/hide of result counts based on the tab selected.
    $('.search-nav').on('click', '.nav-link', function () {
        let tabType = $(this).data('tabtype');
        let seachResultHeadingSelector = `.search-result-count.${tabType}`;
        let resultCountSelector = `.plp-result-count.${tabType}`;
        let resultSuggestionSelector = `.suggestion-wrapper.${tabType}`;
        // hide all results count display and show relevant tab related count display.
        $('.plp-result-count').addClass('d-none');
        $(resultCountSelector).removeClass('d-none');
        // hide all SRP headings and show relevant tab related heading.
        $('.search-result-count').addClass('d-none');
        $(seachResultHeadingSelector).removeClass('d-none');
        // hide all no result suggestions and show relevant tab related no result suggestion
        $('.suggestion-wrapper').addClass('d-none');
        $(resultSuggestionSelector).removeClass('d-none');

        var targetPaneId = $(this).attr('href');
        var $targetPane = $(targetPaneId);
        var $badge = $targetPane.find('.filter-count-custom');
        var storedCount = tabFilterCounts[tabType] || 0;
        var $resetCount = $(`.recipe-filter-count.${tabType}`);
        if (storedCount > 0) {
            $badge.text(storedCount).show();
            $resetCount.text('(' + storedCount + ')');
        } else {
            $badge.text('').hide();
            $resetCount.text('');
        }

        if (tabType === 'support') {
            if ($('#support-results').html().trim() === '') {
                getContent($(this), $('#support-results'));
            }
        }

        if (tabType === 'discover') {
            if ($('#discover-results').html().trim() === '') {
                getContent($(this), $('#discover-results'));
            }
        }
    });
}

baseSearch.applyFilter = function () {
    // Handle refinement "See more" / "See less" toggle - only expands/collapses values, no filter applied
    // Use document for delegation - refinement modal may be outside .container
    $(document).on('click', '.refinement-see-more-btn', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var $btn = $(this);
        var $valuesList = $btn.closest('ul.values');
        if (!$valuesList.length) {
            return;
        }
        var $hiddenItems = $valuesList.find('> .refinement-value-hidden');
        var isExpanded = $btn.attr('data-expanded') === 'true';

        if (isExpanded) {
            $hiddenItems.addClass('d-none');
            $btn.find('.refinement-see-more-text').removeClass('d-none').end()
                .find('.refinement-see-less-text').addClass('d-none');
            $btn.attr('data-expanded', 'false');
        } else {
            $hiddenItems.removeClass('d-none');
            $btn.find('.refinement-see-more-text').addClass('d-none').end()
                .find('.refinement-see-less-text').removeClass('d-none');
            $btn.attr('data-expanded', 'true');
        }

        updateLastVisibleRefinementSpacing();
    });

    // Handle refinement value selection and reset click
    $('.container').on(
        'click',
        '.refinements li button:not(.refinement-see-more-btn), .refinement-bar button.reset, .filter-value button, .swatch-filter button',
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            $.spinner().start();
            $(this).trigger('search:filter', e);

            var searchUrl = $(this).data('href');
            searchUrl = new URL(searchUrl, window.location.origin);

            var clickedCatValue = getClassificationValue(searchUrl.searchParams);
            var permalinkVal = $('.tab-pane.active .permalink').val() || $('.permalink').val() || '';
            var currentCatValue = getClassificationValue(new URL(permalinkVal, window.location.origin).searchParams);
            var isCategoryFilterChange = currentCatValue !== null && clickedCatValue !== currentCatValue;

            if (isCategoryFilterChange) {
                searchUrl = new URL(buildCleanCategoryUrl(searchUrl), window.location.origin);
            }
            
            let pageType = $('.refinement-modal-container:visible').data('pagetype') || '';
            let productCountSelector = `.plp-result-count.${pageType}`;
            var $productCountDisplay = $(productCountSelector).find('.page-product-length');
            var $productPageCountDisplay = $(productCountSelector).find('.page-product-page-length');

            // Get current sort selection to preserve in URL
            var selectedSortOrder = $('[name="sort-order"]:checked').attr('id') || $('[name="recipe-sort-order"]:checked').attr('id');
            
            // Push URL to history for both category pages and search results pages
            var seoUrl = isCategoryFilterChange
                ? searchUrl.href
                : ($(this).data('seo-href') || searchUrl.href);
            if (seoUrl) {
                var seoUrlObj = new URL(seoUrl, window.location.origin);
                // Ensure current sort order is preserved in URL
                if (selectedSortOrder) {
                    seoUrlObj.searchParams.set('srule', selectedSortOrder);
                }
                var normalizedUrl = normalizeUrlEncoding(seoUrlObj.href);
                window.history.pushState({}, null, normalizedUrl);
            }

            var attributeId = '#' + $(this).find('span').last().attr('id');
            var isResetBtn = $(this).is('.refinement-bar button.reset'); // check if reset button was clicked
            
            // Replace srule in searchUrl if it exists (selectedSortOrder already defined above)
            if (searchUrl.searchParams.has('srule') && selectedSortOrder) {
                searchUrl.searchParams.set('srule', selectedSortOrder);
            }
            
            var data = {
                page: $('.grid-footer').data('page-number'),
                selectedUrl: searchUrl.href
            };

            if (!searchUrl.searchParams.has('srule') && selectedSortOrder) {
                data.srule = selectedSortOrder;
            }

            $.ajax({
                url: searchUrl.href,
                data: data,
                method: 'GET',
                success: function (response) {
                    updateFilterCount(searchUrl.href);

                    // On a full reset, clear the "Clear" button count. On a category
                    // filter change, updateFilterCount() has already set the count to
                    // reflect the still-selected category filters, so leave it in place
                    // (clearing it here caused the count to disappear — SC-14492).
                    if (isResetBtn) {
                        $('.recipe-filter-count.product').text('');
                    }

                    parseResults(response);
                    updateLastVisibleRefinementSpacing();
                    dynamicTiledata();
                    dynamicPriceAndPromoData();
                    $.spinner().stop();
                    $(attributeId).parent('button').focus();
                    var $productCountInputValue = $(`.page-products-count.${pageType}`);
                    var $productPageCountInputValue = $(`.page-product-search-length.${pageType}`);
                    var countVal = $productCountInputValue.val();
                    var searchLengthVal = $productPageCountInputValue.val();
                    $productCountDisplay.text(parseInt(countVal, 10) || 0);
                    $productPageCountDisplay.text(parseInt(searchLengthVal ? searchLengthVal.replace(/,/g, '') : '0', 10) || 0);
                    styleProductBadges();
                },
                error: function () {
                    $.spinner().stop();
                    $(attributeId).parent('button').focus();
                }
            });
        }
    );
};

baseSearch.showMore = function () {
    // Show more products
    $('.container').on('click', '.show-more button', function (e) {
        e.stopPropagation();
        var $this = $(this);
        var showMoreUrl = $(this).data('url');
        showMoreUrl += '&isShowMoreProductsCall=' + true;
        e.preventDefault();

        // Find the closest .grid-footer to the clicked .show-more button
        var $gridFooter = $(this).closest('.grid-footer');
        let pageType = $(this).data('pagetype') || '';
        let productCountSelector = `.plp-result-count.${pageType}`;
        var $productCountDisplay = $(productCountSelector).find('.page-product-length');

        if (!window.plpRestoreInProgress) {
            $.spinner().start();
        }
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: function (response) {
                $this.attr('aria-hidden', 'true');
                // Only replace the specific grid-footer that was clicked
                $gridFooter.replaceWith(response);
                $('body').trigger('search:updateDom', $gridFooter);
                updateSortOptions(response);
                // Custom start: update cloudinary responsive images
                if (typeof window.makeCloudinaryImagesResponsive !== 'undefined') {
                    window.makeCloudinaryImagesResponsive();
                }
                var $productCountInputValue = $(`.page-products-count.${pageType}`);
                $productCountDisplay.text(parseInt($productCountInputValue.val(), 10) || 0);
                // Custom end: update cloudinary responsive images
                dynamicTiledata();
                dynamicPriceAndPromoData();
                styleProductBadges();
                if (!window.plpRestoreInProgress) {
                    if (!window.plpScrollRestoreComplete && $(response).find('.product').length > 0) {
                        const pid = $(response).find('.product').first().data('pid');
                        $('.product[data-pid=' + pid + ']').find('.wishlistTile').attr('tabindex', '0').focus();
                    }
                    window.plpScrollRestoreComplete = false;
                    $.spinner().stop();
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

baseSearch.sort = function () {
    // Handle sort order menu selection
    $('.container').on('change', '[name=sort-order], [name=recipe-sort-order]', function (e) {
        e.preventDefault();

        const $select = $(this);
        const selectedUrl = $select.val();
        const $productGrid = $select.closest('.container').find('.product-grid');

        // Update browser URL with sort parameter for back button support
        // Works for both category pages and search results pages
        var urlObj = new URL(selectedUrl, window.location.origin);
        var srule = urlObj.searchParams.get('srule');
        if (srule) {
            var currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('srule', srule);
            var seoUrl = $(this).data('seo-href');
            var finalUrl;
            if (seoUrl) {
                // Use SEO URL if available, append srule
                var seoUrlObj = new URL(seoUrl, window.location.origin);
                seoUrlObj.searchParams.set('srule', srule);
                finalUrl = normalizeUrlEncoding(seoUrlObj.href);
            } else {
                finalUrl = normalizeUrlEncoding(currentUrl.href);
            }
            window.history.pushState({}, null, finalUrl);
        }

        $.spinner().start();
        $select.trigger('search:sort', selectedUrl);

        // Preserve interrupter cards before sort replaces the grid
        var savedCards = preserveInterrupterCards();

        $.ajax({
            url: selectedUrl,
            data: { selectedUrl: selectedUrl },
            method: 'GET',
            success: function (response) {
                $productGrid.empty().html(response);
                restoreInterrupterCards(savedCards);
                $('body').trigger('search:updateDom', $productGrid);
                dynamicTiledata();
                dynamicPriceAndPromoData();
                styleProductBadges();
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

baseSearch.seoShowMore = function () {
    $('.seo-block-wrapper').on('click', '.read-more', function (e) {
        e.preventDefault();
        $('.seo-block-content').toggleClass('expanded');
        let readMoreText = $('.read-more-text').val();
        let readLessText = $('.read-less-text').val();
        $('.read-more').text($('.seo-block-content').hasClass("expanded") ? readLessText : readMoreText);
    });
}

baseSearch.initNoResultsCarousel = function () {
    setTimeout(() => {
        const $containerNoResultsRecommender = $('.no-results-recommender');
        const $noResultSlider = $('.js-no-results-carousel > .row'); 
        const $leftArrowSelectorNoResult = $('.no-results-recommender .left-arrow');
        const $rightArrowSelectorNoResult = $('.no-results-recommender .right-arrow');
        const slidesToShowDesk = 4;
        const slidesToScrollDesk = 1;
        const slidesToShowMobile = 2;
        const slidesToScrollMobile = 1;
        const slidesToShowTab = 3;
        const slidesToScrollTab = 1;

        try {
            if ($noResultSlider.length > 0) {

                $('.no-results-tile').each(function () {
                    const $tile = $(this);

                    // Get all previous siblings until a non-script is found
                    const $scripts = $tile.prevAll('script');

                    if ($scripts.length > 0) {
                        // Combine scripts and the tile in correct order
                        const $elementsToWrap = $($scripts.get().reverse()).add($tile);

                        // Wrap them in a container div
                        $elementsToWrap.wrapAll('<div class="product-unit" style="height:100%"></div>');
                    }
                });


                const $products = $noResultSlider.children();
                $products.hide();

                // Slight delay to ensure layout stability
                setTimeout(() => {
                    try {
                        generateResponsiveSlickCarousel(
                            $noResultSlider,
                            $leftArrowSelectorNoResult,
                            $rightArrowSelectorNoResult,
                            slidesToShowDesk,
                            slidesToScrollDesk,
                            slidesToShowMobile,
                            slidesToScrollMobile,
                            slidesToShowTab,
                            slidesToScrollTab
                        );

                        // Show products after initialization
                        styleProductBadges();
                        $noResultSlider.children().show();
                        $containerNoResultsRecommender.removeClass('d-none');
                    } catch (e) {
                        console.error('Failed to initialize recommendation carousel:', e);
                    }
                }, 50); // optional slight delay


            } else {
                console.warn('No result carousel selector not rendered');
            }
        } catch (e) {
            console.error('Failed to initialize recommendation carousel:', e);
        }
    }, 2000);
};

// Handle Support Tab Load More
baseSearch.showMoreArticles = function () {
    $(document).on('click', '.show-more-articles', function (e) {
        e.preventDefault();
        articlesCount = Number($('.articleMinCount').val()) || 8;
        var $button = $(this).find('.btn.more');

        if ($button.length === 0) return;

        $.spinner().start();

        var showMoreUrl = $button.data('url');
        var nextPageUrl = $button.data('nextpageurl') || '';
        var $loadMoreWrapper = $(this);

        $.ajax({
            url: showMoreUrl,
            data: { nextPageUrl: nextPageUrl },
            method: 'GET',
            success: function (response) {
                if (response) {
                    var $responseHtml = $('<div>').html(response);

                    // Append new support articles
                    $responseHtml.find('.support-section-item').each(function () {
                        $('.support-section-container').append(this);
                        articlesCount += 1;
                    });

                    // Replace or remove Load More section
                    var $newLoadMore = $responseHtml.find('.show-more-articles');
                    if ($newLoadMore.length > 0) {
                        $loadMoreWrapper.replaceWith($newLoadMore);
                    } else {
                        $loadMoreWrapper.remove();
                    }

                    if ($('.plp-result-count').hasClass('support')) {
                        $('.plp-result-count.support .page-product-length').text(articlesCount);
                    }
                    $('.articleMinCount').val(articlesCount);
                    // Optional trigger or reinitialization
                    $('body').trigger('support:updateDom', $loadMoreWrapper);
                }
                $.spinner().stop();
            },
            error: function () {
                console.error('Support Load More failed');
                $.spinner().stop();
            }
        });
    });
}

baseSearch.popularTilesSelectedState = function() {
    var $popularTiles = $('.popular-category-tile');
    var currentPath = getRelativeCategoryUrl() || '';

    // Helper function to safely compare paths and query parameters
    /**
     * Safely compare paths and query parameters
     * This function ensures that the URLs are exactly the same, including path and query parameters
     * @param {string} url1 - The first URL to compare
     * @param {string} url2 - The second URL to compare
     * @returns {boolean} - True if the URLs are exactly the same, false otherwise
     */
    function isExactUrlMatch(url1, url2) {
        if (!url1 || !url2) return false;

        try {
            var base = window.location.origin;
            var u1 = new URL(url1, base);
            var u2 = new URL(url2, base);

            if (u1.pathname !== u2.pathname) return false;

            u1.searchParams.sort();
            u2.searchParams.sort();

            return u1.searchParams.toString() === u2.searchParams.toString();
            
        } catch (e) {
            return url1 === url2; 
        }
    }

    $popularTiles.each(function() {
        var tileHref = $(this).find('a').first().attr('href');
        
        if (isExactUrlMatch(tileHref, currentPath)) {
            $(this).addClass('selected');
        }
    });
}

/** 
 * Store product data in sessionStorage.
 *
 * @param {string|number} productId - Product identifier.
 * @param {number|null} startIndex - Start index for "load more" (optional).
 * @param {number|null} sz - Page size (optional).
 * @param {string} pageType - Page type from the show more button (e.g. "product", "recipe").
 */
function storeProductDataInSession(productId, startIndex, sz, pageType) {
    sessionStorage.setItem('lastClickedProductId', productId);
    if (startIndex !== null) {
        sessionStorage.setItem('lastLoadMoreStartIndex', startIndex);
    }
    if (sz !== null) {
        sessionStorage.setItem('lastPageSize', sz);
    }
    if (pageType) {
        sessionStorage.setItem('lastPageType', pageType);
    }
    sessionStorage.setItem('lastPlpUrl', window.location.href);
}

baseSearch.savePlpState = function () {
    var clickSelector = '.tile-image-link, .product-name-link, .see-details-link, .tile-body .pdp-link .link';

    $(document)
        .off('click.savePlpState', clickSelector)
        .on('click.savePlpState', clickSelector, function () {
            var $tile = $(this).closest('.js-grid-tile');
            var productId = $tile.data('pid');

            var $tabPane = $tile.closest('.tab-pane');
            var $loadMoreButton = $tabPane.length
                ? $tabPane.find('.btn.btn-primary.more')
                : $('.btn.btn-primary.more').first();
            var loadMoreUrl = $loadMoreButton.data('url');
            var pageType = $loadMoreButton.data('pagetype') || '';
            if (!pageType && $tabPane.length) {
                pageType = $tabPane.find('[data-pagetype]').first().data('pagetype') || '';
            }
            var permaLinkUrl = $('.permalink').val();
            var startIndex = null;
            var sz = null;

            if (loadMoreUrl) {
                var qs = loadMoreUrl.indexOf('?') >= 0 ? loadMoreUrl.substring(loadMoreUrl.indexOf('?') + 1) : loadMoreUrl;
                var urlParams = new URLSearchParams(qs);
                startIndex = urlParams.get('start');
                sz = urlParams.get('sz');
            } else if (permaLinkUrl) {
                var permaStr = String(permaLinkUrl || '');
                var permaQs = permaStr.indexOf('?') >= 0 ? permaStr.substring(permaStr.indexOf('?') + 1) : permaStr;
                var urlParamsPermaLink = new URLSearchParams(permaQs);
                startIndex = urlParamsPermaLink.get('start');
                sz = urlParamsPermaLink.get('sz');
            }

            if (productId) {
                storeProductDataInSession(productId, startIndex, sz, pageType);
            }
        });
};


$(document).ready(function () {
    var productId = sessionStorage.getItem('lastClickedProductId');

    if (productId) {
        var storedPlpUrl = sessionStorage.getItem('lastPlpUrl');
        if (storedPlpUrl) {
            try {
                var storedUrl = new URL(storedPlpUrl, window.location.origin);
                var currentParams = new URLSearchParams(window.location.search);
                var isSamePlp = window.location.pathname === storedUrl.pathname
                    && (currentParams.get('cgid') || '') === (storedUrl.searchParams.get('cgid') || '')
                    && (currentParams.get('q') || '') === (storedUrl.searchParams.get('q') || '');

                if (!isSamePlp) {
                    sessionStorage.removeItem('lastClickedProductId');
                    sessionStorage.removeItem('lastLoadMoreStartIndex');
                    sessionStorage.removeItem('lastPageSize');
                    sessionStorage.removeItem('lastPageType');
                    sessionStorage.removeItem('lastPlpUrl');
                    productId = null;
                }
            } catch (e) {
                sessionStorage.removeItem('lastClickedProductId');
                sessionStorage.removeItem('lastLoadMoreStartIndex');
                sessionStorage.removeItem('lastPageSize');
                sessionStorage.removeItem('lastPageType');
                sessionStorage.removeItem('lastPlpUrl');
                productId = null;
            }
        }
    }

    /**
     * Cleans up the restore flag and stops the spinner after scroll restoration.
     */
    function finishRestore() {
        if (window.plpRestoreInProgress) {
            window.plpRestoreInProgress = false;
            $.spinner().stop();
            sessionStorage.removeItem('lastClickedProductId');
            sessionStorage.removeItem('lastLoadMoreStartIndex');
            sessionStorage.removeItem('lastPageSize');
            sessionStorage.removeItem('lastPageType');
            sessionStorage.removeItem('lastPlpUrl');
        }
    }

    if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
    }

    /**
     * Polls for a product tile and scrolls to it once found.
     * @param {string} targetProductId - The ID of the product to scroll to
     */
    function scrollToProduct(targetProductId) {
        var startTime = Date.now();
        var timeout = 5000;
        var pollInterval = 200;
    
        var poll = setInterval(function () {
            var $targetTile = $('.product.js-grid-tile[data-pid="' + targetProductId + '"]');
            
            if ($targetTile.length) {
                clearInterval(poll);
                
                var scrollAttempts = 0;
                var maxAttempts = 6; // Prevents an infinite loop
    
                // Secondary interval to ensure it actually stays in the viewport
                var scrollAndVerify = setInterval(function () {
                    var rect = $targetTile[0].getBoundingClientRect();
                    
                    // Check if the product is visibly inside the viewport 
                    // We use 100px buffer on top to account for potential sticky headers
                    var isInViewport = (
                        rect.top >= 100 && 
                        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
                    );
    
                    if (isInViewport || scrollAttempts >= maxAttempts) {
                        clearInterval(scrollAndVerify);
                        finishRestore();
                        window.plpScrollRestoreComplete = true;
                    } else {
                        // scrollIntoView with 'center' prevents it from hiding under headers
                        $targetTile[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                        scrollAttempts++;
                    }
                }, 400); // Wait 400ms between checks to let lazy-loaded images settle
    
            } else if (Date.now() - startTime > timeout) {
                finishRestore();
                clearInterval(poll);
            }
        }, pollInterval);
    }

    // Scroll to product if productId exists
    if (productId != null) {
        window.plpRestoreInProgress = true;
        $.spinner().start();

        var lastStartIndex = parseInt(sessionStorage.getItem('lastLoadMoreStartIndex'), 10);
        var lastPageSize = parseInt(sessionStorage.getItem('lastPageSize'), 10);
        var storedPageType = sessionStorage.getItem('lastPageType') || '';
        var btnSelector = storedPageType
            ? '.btn.btn-primary.more[data-pagetype="' + storedPageType + '"]'
            : '.btn.btn-primary.more';
        var $btn = $(btnSelector);

        var bulkLoadPages = function () {
            var $targetTile = $('.product.js-grid-tile[data-pid="' + productId + '"]');

            if ($targetTile.length > 0 || $btn.length === 0) {
                scrollToProduct(productId);
                return;
            }

            if (Number.isNaN(lastStartIndex) || Number.isNaN(lastPageSize) || lastPageSize <= 0) {
                $('body').one('search:updateDom', function () {
                    scrollToProduct(productId);
                });
                $btn.trigger('click');
                return;
            }

            var btnUrl = $btn.data('url');
            var urlObj = new URL(btnUrl, window.location.origin);
            var currentStart = parseInt(urlObj.searchParams.get('start'), 10) || 0;
            var defaultPageSize = parseInt(urlObj.searchParams.get('sz'), 10) || 0;

            var pageType = $btn.data('pagetype') || '';

            if (lastStartIndex === 0 && defaultPageSize > 0 && lastPageSize > defaultPageSize) {
                lastStartIndex = lastPageSize;
                lastPageSize = defaultPageSize;
            }

            var lastPageStart = lastStartIndex - lastPageSize;
            var bulkSize = lastPageStart - currentStart;

            if (bulkSize < 0 && defaultPageSize > 0) {
                var totalFromDom = parseInt($(`.page-product-search-length.${pageType}`).val(), 10);
                if (!Number.isNaN(totalFromDom) && totalFromDom > currentStart) {
                    lastPageStart = Math.floor((totalFromDom - 1) / defaultPageSize) * defaultPageSize;
                    if (lastPageStart < currentStart) {
                        lastPageStart = currentStart;
                    }
                    bulkSize = lastPageStart - currentStart;
                    lastPageSize = defaultPageSize;
                }
            }

            if (bulkSize > 0) {
                var bulkUrl = new URL(btnUrl, window.location.origin);
                bulkUrl.searchParams.set('start', currentStart);
                bulkUrl.searchParams.set('sz', bulkSize);
                bulkUrl.searchParams.set('isShowMoreProductsCall', 'true');

                var $gridFooter = $btn.closest('.grid-footer');

                $.ajax({
                    url: bulkUrl.toString(),
                    data: { selectedUrl: bulkUrl.toString() },
                    method: 'GET',
                    success: function (bulkResponse) {
                        $gridFooter.replaceWith(bulkResponse);
                        $('body').trigger('search:updateDom', '.grid-footer');
                        updateSortOptions(bulkResponse);
                        if (typeof window.makeCloudinaryImagesResponsive !== 'undefined') {
                            window.makeCloudinaryImagesResponsive();
                        }
                        dynamicTiledata();
                        dynamicPriceAndPromoData();
                        styleProductBadges();

                        var lastUrl = new URL(btnUrl, window.location.origin);
                        lastUrl.searchParams.set('start', lastPageStart);
                        lastUrl.searchParams.set('sz', lastPageSize);
                        lastUrl.searchParams.set('isShowMoreProductsCall', 'true');

                        var $newGridFooter = $(btnSelector).closest('.grid-footer');

                        $.ajax({
                            url: lastUrl.toString(),
                            data: { selectedUrl: lastUrl.toString() },
                            method: 'GET',
                            success: function (lastResponse) {
                                $newGridFooter.replaceWith(lastResponse);
                                $('body').trigger('search:updateDom', '.grid-footer');
                                updateSortOptions(lastResponse);
                                if (typeof window.makeCloudinaryImagesResponsive !== 'undefined') {
                                    window.makeCloudinaryImagesResponsive();
                                }
                                var $pCountInput = $(`.page-products-count.${pageType}`);
                                var $pCountDisplay = $(`.plp-result-count.${pageType}`).find('.page-product-length');
                                if ($pCountInput.length && $pCountDisplay.length) {
                                    $pCountDisplay.text(parseInt($pCountInput.val(), 10));
                                }
                                dynamicTiledata();
                                dynamicPriceAndPromoData();
                                styleProductBadges();
                                scrollToProduct(productId);
                            },
                            error: function () {
                                scrollToProduct(productId);
                            }
                        });
                    },
                    error: function () {
                        scrollToProduct(productId);
                    }
                });
            } else if (bulkSize === 0) {
                $('body').one('search:updateDom', function () {
                    scrollToProduct(productId);
                });
                $btn.trigger('click');
            } else {
                scrollToProduct(productId);
            }
        };

        bulkLoadPages();
    }

    updateFilterCount(window.location.href);
    updateLastVisibleRefinementSpacing();
});

// Remove margin bottom from category carousel if it is the last element in PDP top section
$(document).ready(function () {
    var $parent = $('.pdp-top-section');
    var $lastChild = $parent.children().last();

    if ($lastChild.hasClass('experience-plp-categoryCarouselLayout')) {
        $lastChild.find('.plp-category-carousel-wrapper').css('margin-bottom', '0');
    }
});

/**
 * Initializes all custom logic
 */
baseSearch.initCustomSearch = function () {
    dynamicTiledata();
    dynamicPriceAndPromoData();
    styleProductBadges();
}

// Disable bfcache for PLP pages
// Adding an unload listener prevents the browser from caching this page in bfcache
window.addEventListener('unload', function() {
    // This empty handler prevents bfcache
});

// Handle pageshow as a fallback in case bfcache still triggers
window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
        // Page was restored from bfcache - force reload
        window.location.reload();
    }
});

baseSearch.onPopState = function () {
    // Handle popstate event (back/forward navigation)
    $(window).on('popstate', function () {
        window.location.reload();
    });
};

module.exports = baseSearch;
